export default __webpack_public_path__ + "static/media/10.055455e0.jpg";